import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

export default (props) => (
  <Spinner animation="border" role="status" variant={props.variant || 'light'}>
    <span className="sr-only">Loading...</span>
  </Spinner>
);
